import { getCountry } from '@iwIntlProvider/CountryProvider';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { REQUEST_CHANGE_ROUTER } from '../../../iwRouter/IwRouter.actions';
import StopWatchSVG from '../../../svgComponents/stopWatchSVG/StopWatchSVG';
import { TickCircleSVG } from '../../../svgComponents/tickCircleSVG';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';
import styles from './ApprovalExpiredView.module.css';
import messages from './ApprovalExpiredView.messages';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    requestReapply: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/apply-flexi-loan/'
            }
        })
});

const ApprovalExpiredView = ({
    requestReapply
}: ReturnType<typeof mapDispatchToProps>) => {
    return (
        <MainSectionWrapper>
            <div className={styles.card}>
                <div className={styles.svgContainer}>
                    <StopWatchSVG />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                <div className={styles.subtitle}>
                    <FormattedMessage {...messages.subtitle} />
                </div>
                <hr className={styles.divider} />

                <div className={styles.reminderTitle}>
                    <FormattedMessage {...messages.reminderTitle} />
                </div>
                <div className={styles.reminders}>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName={'span'}
                            {...messages.decision}
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName="span"
                            {...messages.borrowAmount}
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName="span"
                            {...messages.repayEarly}
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                </div>

                <div className={styles.questions}>
                    <FormattedMessage
                        tagName="strong"
                        {...messages.questions}
                        values={{
                            phoneNumber: (
                                <a
                                    href={
                                        getCountry() === 'DE'
                                            ? 'tel:069 9432 3020 '
                                            : 'tel:020 3778 0274'
                                    }
                                    className={styles.phoneNumber}
                                >
                                    <FormattedMessage
                                        tagName="strong"
                                        {...messages.phoneNumber}
                                    />
                                </a>
                            )
                        }}
                    />
                </div>

                <div className={styles.cta}>
                    <Button
                        data-testid="re-apply-cta"
                        variant="primary"
                        className={styles.ctaButton}
                        onClick={requestReapply}
                        data-action-name="Approval expired reapply"
                    >
                        <FormattedMessage {...messages.cta} />
                    </Button>
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(ApprovalExpiredView);
